export default ({ primary }) => ({
  '.has-text-primary': {
    color: `${primary} !important`,
  },
});
